// removed by extract-text-webpack-plugin
module.exports = {"collaborator-invite-modal":"collaborator-invite-modal","modal-body":"modal-body","form-description":"form-description"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/collaborator-invite-modal/collaborator-invite-modal.style.sass
// module id = eS9E
// module chunks = 0